export type ProfileGender = 'female' | 'male';

interface GenderLike {
  displayName?: string;
  email?: string;
  gender?: ProfileGender;
}

export function inferGender(profile?: GenderLike | null): ProfileGender | undefined {
  if (!profile) return undefined;
  if (profile.gender === 'female' || profile.gender === 'male') return profile.gender;
  const text = `${profile.displayName || ''} ${profile.email || ''}`.toLocaleLowerCase('tr-TR');
  if (text.includes('ayça') || text.includes('ayca')) return 'female';
  if (text.includes('serhat')) return 'male';
  return undefined;
}

export function canUseCycleFeature(members: GenderLike[]) {
  const genders = members.map(inferGender);
  if (genders.length >= 2 && genders.every(gender => gender === 'male')) return false;
  return genders.some(gender => gender === 'female') || genders.some(gender => !gender);
}

export function isFemaleProfile(profile?: GenderLike | null) {
  return inferGender(profile) === 'female';
}
